export const ARMOUR_SLOT_HP = 2;
export const MAX_ARMOUR_SLOTS = 3;

export function getArmourSlots(armour) {
    const value = armour?.armourSlots ?? armour?.hitpoints ?? 0;
    const slots = Number(value);
    return Number.isFinite(slots) ? Math.max(0, Math.floor(slots)) : 0;
}

export function createSlotStates(slotCount, existingStates = []) {
    const count = Math.max(0, Math.floor(Number(slotCount) || 0));
    return Array.from({ length: count }, (_, index) => {
        const existing = existingStates[index];
        const hp = Number(existing?.hp);
        const maxHp = Number(existing?.maxHp) || ARMOUR_SLOT_HP;
        return {
            hp: Number.isFinite(hp)
                ? Math.max(0, Math.min(maxHp, hp))
                : ARMOUR_SLOT_HP,
            maxHp: ARMOUR_SLOT_HP,
        };
    });
}

export function normalizeArmour(armour) {
    if (!armour || typeof armour !== "object") return armour;

    const slots = getArmourSlots(armour);
    const existingStates = Array.isArray(armour.slotStates)
        ? armour.slotStates
        : [];

    if (!existingStates.length && Number(armour.damage) > 0) {
        const damagedSlots = Math.min(slots, Math.floor(Number(armour.damage)));
        armour.slotStates = createSlotStates(slots).map((slot, index) =>
            index < damagedSlots ? { ...slot, hp: 0 } : slot
        );
    } else {
        armour.slotStates = createSlotStates(slots, existingStates);
    }

    armour.armourSlots = slots;
    delete armour.hitpoints;
    delete armour.damage;
    return armour;
}

export function functioningArmourSlots(armour) {
    return createSlotStates(
        getArmourSlots(armour),
        Array.isArray(armour?.slotStates) ? armour.slotStates : []
    ).filter((slot) => slot.hp > 0).length;
}

export function occupiedArmourSlots(character) {
    return (character?.armour || []).reduce(
        (total, armour) => total + getArmourSlots(armour),
        0
    );
}

export function canEquipArmour(character, armour) {
    return occupiedArmourSlots(character) + getArmourSlots(armour) <= MAX_ARMOUR_SLOTS;
}

export function armourAbilitiesActive(armour) {
    return functioningArmourSlots(armour) > 0;
}